import React, { useEffect, useState } from 'react';
import { json, Link } from 'react-router-dom';
import Notifications from './Notification';
import User from './User';
import Logoo from './Logoo';
import SideNavButton from './SideNavButton';
import SearchBar from './SearchBar';

const Nav = () => {
    const auth = localStorage.getItem('token');
    const [count, setCount] = useState(0);

    useEffect(() => {
    if (count === 1) {
        setCount(2);
        window.location.reload();
    }
}, [count]);

       const toggleSidebar = () => {
        const wrapper = document.getElementById("wrapper");
        if (wrapper) {
            wrapper.classList.toggle("toggled");
        }
    };

    return (
        <>

            <div id="header-sticky">
                <div className="navbar-custom">
                    {auth ?
                        <>

                            {/* <!-- LOGO --> */}
                            <div className='container-fluid'>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='logo-sidebtn'>
                                            <SideNavButton />
                                            <Logoo />


                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='side-notification'>
                                            <ul className="list-unstyled topnav-menu float-right mb-0">

                                                <Notifications />

                                                <User setCount={setCount} />
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>




                        </>

                        :
                        <>
                            <div className='container-fluid'>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        <div>
                                            <span className="logo-lg sign-logo">
                                                <img src="assets/images/campaleads.png" alt="" />
                                                {/* <!-- <span className="logo-lg-text-light">UBold</span> --> */}
                                            </span>
                                        </div>
                                    </div>
                                    {/* <div className='col-md-8'>
                                        <div className='top-btn'>
                                            <ul className="list-unstyled topnav-menu float-right mb-0 bfr-login">

                                                <li>
                                                    <Link to="/login" className="nav-link nav-user mr-0 waves-effect waves-light">
                                                        <span className="ml-1">Login </span>
                                                    </Link>
                                                </li>

                                            </ul>
                                        </div>
                                    </div> */}
                                </div>

                            </div>







                        </>

                    }

                </div>
            </div>
            {/* {
                process.env.REACT_APP_ENV === "prod" ?
                    <div
                        style={{
                            backgroundColor: 'rgb(231, 231, 97)',
                            marginTop: "70px",
                            marginBottom: "-50px",
                        }}
                    >
                        <h1 style={{ marginLeft: "90px" }}>Only for Demo  </h1>
                    </div> : ""
            } */}

        </>

    )

}

export default Nav;